// ============================================================================
// File: src/modules/ppe/pages/reports/lifecycle/LifecycleReportPage.jsx
// Module: PPE → Reports → Lifecycle
// Purpose:
//   Lifecycle report page
//   - Calls lifecycle API
//   - Renders filters
//   - Displays graph + tables
// ============================================================================

import React, { useState } from "react";
import "./styles/lifecycle.css";

import LifecycleHeader from "./components/LifecycleHeader";
import LifecycleFilters from "./components/LifecycleFilters";
import LifecycleSummary from "./components/LifecycleSummary";
import LifecycleGraph from "./components/LifecycleGraph";
import LifecycleTabs from "./components/LifecycleTabs";

import { fetchLifecycleReport } from "./services/lifecycleService";

export default function LifecycleReportPage() {

  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [error, setError] = useState(null);

  // ---------------------------------------------------------------------------
  // LOAD REPORT
  // ---------------------------------------------------------------------------
const loadReport = async (filters) => {

  try {

    setLoading(true);
    setError(null);

    const response = await fetchLifecycleReport(filters);

    console.log("Lifecycle Report Response:", response);

    if (!response || response.success === false) {
      throw new Error(response?.message || "Failed to load lifecycle report");
    }

    // Correct extraction
    setReportData(response.data);

  } catch (err) {

    console.error("Lifecycle Report Error:", err);
    setError(err.message || "Failed to load lifecycle report");

  } finally {

    setLoading(false);

  }

};

return (

  <div className="lifecycle-report-page">

    <LifecycleHeader />

    {/* FILTER + GRAPH ROW */}

    <div className="lifecycle-top-section">

      <div className="lifecycle-filter-panel">
        <LifecycleFilters onSearch={loadReport} />
      </div>

      <div className="lifecycle-graph-panel">
        {reportData?.graph && (
          <LifecycleGraph graph={reportData.graph} />
        )}
      </div>

    </div>

    {/* KPI SUMMARY */}

    {reportData && (
      <LifecycleSummary data={reportData} />
    )}

    {/* TABS */}

    {reportData && (
      <LifecycleTabs
        data={reportData}
        loading={loading}
      />
    )}

  </div>

);

}